import { getFullUrl } from 'hubspot-url-utils';
import { useTranslation } from '../../../hooks/useNavConfig';
import { AccountExtraLink } from './AccountExtrasLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductUpdatesLink = ({
  portalId,
  isDevPortal
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "productUpdates",
    link: `${getFullUrl('app')}/product-updates/${portalId}`,
    linkText: t('nav.tools.productUpdates'),
    dividerAbove: !isDevPortal
  });
};